<template>
	<div class="app-container">
		<div class="h1-buttons">
			<h1 v-if="wizardStep !== 'TestRunner'">Git Config Pull - {{wizardTitle[wizardStep]}}</h1>
		</div>

		<GitConfig v-if="wizardStep==='Pull'" :type="'Pull'" @remoteDataReceived="onRemoteDataReceived" />
		<Manifest v-if="wizardStep==='Manifest'" :remoteObjects="remoteFiles" @back="goToStep('Pull')" @next="confirmSelectedFiles" />
		<GitDiff v-if="wizardStep==='Diff'" :remoteObjects="remoteFiles" :uuid="uuid" :selectedObjects="selectedFiles" @back="goToStep('Manifest')" @next="goToStep('TestRunner')" />
		<TestRunner v-if="wizardStep==='TestRunner'" :showBackButton="true" @back="goToStep('Diff')" />
	</div>
</template>

<script>
import GitConfig from './GitConfig';
import Manifest from './Manifest';
import GitDiff from './GitDiff';
import TestRunner from '../test-runner/TestRunner';
import { convertToList } from '../../util/gitDiff';

export default {
	name: "GitPullWizard",
	components: {
		GitConfig,
		Manifest,
		GitDiff,
		TestRunner
	},
	data() {
		return {
			wizardStep: 'Pull',
			remoteFiles: {},
			selectedFiles: [],
			uuid: '',
			wizardTitle: {
				'Pull': 'Enter Your Credentials',
				'Manifest': 'Remote Content (Preview)',
				'Diff': 'Merge Changes',
				'TestRunner': 'Test Runner'
			}
		};
	},
	methods: {
		onRemoteDataReceived(remoteData) {
			if (remoteData) {
				this.remoteFiles = {};
				for (const service of remoteData.services) {
					this.remoteFiles[service.serviceId] = convertToList(service);
				}
				this.uuid = remoteData.uuid;
				this.wizardStep = 'Manifest';
			}
		},
		goToStep(step) {
			this.wizardStep = step;
		},
		confirmSelectedFiles(selectedFiles) {
			this.selectedFiles = selectedFiles;
			this.wizardStep = "Diff";
		}
	}
};
</script>
